exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".is-title[data-v-39d1ac02]{text-transform:capitalize}", ""]);
